import { type AccountStatus } from '@entities/account';

import { type Account } from '@services/AccountService';

/**
 * The «Анкета» section shows with the matchmaker feature, and always while
 * dating is off (a flag rollback must not strand a user who cannot turn it
 * back on). An unknown state shows it too, as a loader or a retry, never as
 * defaults.
 */
export const isAccountSettingsShown = (
  status: AccountStatus,
  account: Account | null,
) => {
  if (status === 'unknown' || !account) return true;

  return account.features.matchmaker || !account.dating;
};
